import { configureStore } from '@reduxjs/toolkit'
import commonReducer from 'features/commonSlice'
import firmReportReducer from 'features/firmReportSlice'

export default configureStore({
    reducer: {      
        common : commonReducer,    
        firmReport : firmReportReducer,    
    }
})